import { Link, useNavigate } from 'react-router-dom';
import { Space, Tag, Button, Modal, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { ResourceList } from '@/components/ResourceList';
import { archiveApp, listApps, type App } from '@/api/apps';
import { formatDateTime } from '@/utils/format';

const statusColor: Record<string, string> = {
  active: 'green',
  draft: 'gold',
  archived: 'default',
};

export function AppsListPage() {
  const navigate = useNavigate();

  const handleArchive = (row: App) => {
    Modal.confirm({
      title: `确认归档 App「${row.name}」?`,
      content: '归档后该 App 不再对终端用户可见；可以重新激活。',
      okText: '归档',
      okType: 'danger',
      cancelText: '取消',
      onOk: async () => {
        try {
          await archiveApp(row.id);
          message.success('已归档');
          window.location.reload();
        } catch (e) {
          message.error(e instanceof Error ? e.message : '操作失败');
        }
      },
    });
  };

  return (
    <ResourceList<App>
      title="App 配置"
      description="一个 App = 一个产品入口；slug 不可更改，theme / routes / config 可热更新。"
      rowKey="id"
      pagination="offset"
      filters={[
        { key: 'q', label: '关键字', type: 'text', placeholder: '名称或 slug' },
        {
          key: 'status',
          label: '状态',
          type: 'select',
          options: [
            { value: 'active', label: '活跃' },
            { value: 'draft', label: '草稿' },
            { value: 'archived', label: '已归档' },
          ],
        },
      ]}
      fetcher={({ filters, page, pageSize }) =>
        listApps({ ...filters, page, page_size: pageSize } as never)
      }
      actions={[
        {
          label: '新建 App',
          icon: <PlusOutlined />,
          onClick: () => navigate('/apps/new'),
        },
      ]}
      columns={[
        { title: 'ID', dataIndex: 'id', width: 80 },
        {
          title: '名称',
          dataIndex: 'name',
          render: (_, row) => <Link to={`/apps/${row.id}`}>{row.name}</Link>,
        },
        { title: 'slug', dataIndex: 'slug', render: (v) => <Tag>{v}</Tag> },
        {
          title: '状态',
          dataIndex: 'status',
          render: (v) => <Tag color={statusColor[v] || 'default'}>{v}</Tag>,
        },
        {
          title: '更新时间',
          dataIndex: 'updated_at',
          render: (v) => formatDateTime(v),
        },
        {
          title: '操作',
          key: 'actions',
          width: 200,
          render: (_, row) => (
            <Space>
              <Button size="small" onClick={() => navigate(`/apps/${row.id}`)}>
                详情
              </Button>
              <Button size="small" danger onClick={() => handleArchive(row)}>
                归档
              </Button>
            </Space>
          ),
        },
      ]}
    />
  );
}
